import React,{useEffect, useState} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { Modal } from "react-bootstrap";
import axios from 'axios'
import swal from "sweetalert2";

const EditToPrepareModal = (props) =>{
    const t =useTranslate()
    const [validButton,setValidButton]=useState(false)
    const [qty,setQty]=useState(props.item.to_prepare_qty)
    const idsLocalStorage=(props.module=='pos' ) ? localStorage.getItem("pos").split(',') : [0,0]

    const handleChange = (e) =>{
        if(e.target.value==''){  
            //Permet d'autoriser la suppréssion du chiffre afin d'écrire ce qu'on veut
            setQty(e.target.value)
        }else if(+e.target.value >= 0 && +e.target.value<=props.item.quantity){
            //Permet de contraindre l'utilisateur à n'écrire que des chiffres
            setQty(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..{2}).*/g, '$1'))
        }
    }

    const handleSubmit = async (e) =>{
        e.preventDefault();

        if(props.module=='pos'){
            setValidButton(true)
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0], {
                id:props.cookies.current_ticket,
                detail_id:props.lineId,
                to_prepare_qty:qty
            }).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{   
                    props.setCurrentTicket(response.data.data)
                    props.closeModal('to_prepare')
                    setValidButton(false)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setValidButton(false)
        }
    }

    // Pour reset la quantité à préparer à chaque ouverture de la modale
    useEffect(function () {
        setQty(props.item.to_prepare_qty)
    },[props.showEditToPrepare])

    return(
        <Modal size="md" show={props.showEditToPrepare} onHide={() => props.closeModal('to_prepare')}>
            <Modal.Header closeButton>
                <Modal.Title>{t('editToPrepare')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={(e)=>handleSubmit(e)}>
                    <div className="row">
                        <div className="col">
                            <input className='form-control' type='number' value={qty} onChange={(e)=>handleChange(e)} min={0} max={props.item.quantity}/>
                        </div>
                    </div>
                    <button disabled={validButton} className="btn btn-primary mt-3">
                        {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default EditToPrepareModal;